import register from '../../../../global/js/registry';
export default register('m-pdf-list-toolbar', () => import(/* webpackMode: "lazy" */ './m-pdf-list-toolbar.controller'));
